export default function PIXMA_G2910() {

    return <>
        <p> <img src="https://image.kr.canon/re/product/2021110223113001_33172139.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2021110410362401_34085051.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2022041914060001_12396384.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2022041914062801_12434422.jpg" width="98%" /> </p>
    </>
}